import { render } from "./App.vue?vue&type=template&id=28830ebc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=28830ebc&lang=css"
script.render = render

export default script